import { render, staticRenderFns } from "./MrpController.vue?vue&type=template&id=709bc7d2"
import script from "./MrpController.vue?vue&type=script&lang=js"
export * from "./MrpController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports